<template>
  <div class="d-flex flex-column full-width">
    <div class="align-center d-flex">
      <div class="full-width">
        <v-text-field
          autocomplete="off"
          class="search-box-radius"
          background-color="#ffffff"
          hide-details="true"
          type="search"
          label="Search for products"
          @focus="$router.push({name: 'search'})"
          outlined
          dense
        ></v-text-field>
      </div>
      <div>
        <v-btn small depressed class="search-button-radius" color="primary" height="40">
          <img alt="search" src="@/assets/banner/ic-search.svg" height="15" width="13" />
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InactiveXsSearch"
};
</script>

<style scoped>
.search-button-radius {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;
}
.search-box-radius {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;
}
</style>
